<div *ngFor="let supplier of interfaceDataSuppliers | keyvalue" class="row">
  <div class="col-12">
    <b>{{adminSupplierInterfaceService.getSupplierName(supplierInterfaceData.SupplierData, +supplier.key)}}</b><span class="ms-3 text-low">({{supplier.key}})</span>
  </div>
  <div class="col-12">
    <app-default-interface-data-settings [interfaceDatas]="supplier.value" [supplierInterfaceData]="supplierInterfaceData" (interfaceDataChanged)="interfaceDataChanged.emit($event)"></app-default-interface-data-settings>
  </div>
</div>